import React from 'react';
import useAuth from '@hooks/useAuth';
import { capitalizeName } from '@utils/commons';
import UploadImage from '@components/upload-image';

const UserProfileCard = () => {
  const { profile } = useAuth();

  return (
    <div>
      <h1 className="govuk-heading-l underline">
        Hello {capitalizeName(profile?.full_name || '')}
      </h1>
      <div className="govuk-grid-row mb-5">
        <div className="govuk-grid-column-one-third">
          <UploadImage
            isEditable={false}
            isCustomized
            title="Add a recent profile photo"
            imageUrl={profile?.avatar || ''}
            setImageUrl={() => {}}
          />
        </div>
      </div>
    </div>
  );
};

export default UserProfileCard;
